import { useEffect, useRef } from 'react'
import type { JSX } from 'react'

import { Flex, Link, Text, UpgradeBadge } from '@buffer-mono/popcorn'
import {
  BufferTrackerReact as BufferTracker,
  Client,
} from '@buffer-mono/tracking-plan'

import {
  useIsFreeUser,
  useOrganizationId,
} from '~publish/contexts/AccountContext'
import { MODALS, useOpenGlobalModal } from '~publish/hooks/useOpenGlobalModal'

const cta = 'publish-settings-api-freePlanUsageNotice-1' as const
const upgradePathName = 'apiFreePlan-upgrade' as const

export function FreePlanUpgradeNotice(): JSX.Element | null {
  const isFreeUser = useIsFreeUser()
  const organizationId = useOrganizationId()
  const openGlobalModal = useOpenGlobalModal()
  const hasTrackedViewRef = useRef(false)

  useEffect(() => {
    if (!isFreeUser || hasTrackedViewRef.current) return

    BufferTracker.upgradePathViewed({
      clientName: Client.PublishWeb,
      product: 'publish',
      organizationId: organizationId ?? '',
      upgradePathName,
      cta,
    })
    hasTrackedViewRef.current = true
  }, [isFreeUser, organizationId])

  if (!isFreeUser) {
    return null
  }

  const handleUpgradeClick = (): void => {
    BufferTracker.cTAClicked({
      clientName: Client.PublishWeb,
      product: 'publish',
      organizationId: organizationId ?? '',
      upgradePathName,
      cta,
    })

    openGlobalModal(MODALS.planSelector, {
      cta,
      upgradePathName,
      planSelector: {
        initialStep: 'upgrade',
      },
    })
  }

  return (
    <Flex align="center" gap="xs">
      <UpgradeBadge size="small" />
      <Text color="subtle">
        <Text as="span" weight="medium">
          Keep your API workflows running smoothly.
        </Text>{' '}
        <Link as="button" color="inherit" onClick={handleUpgradeClick}>
          Upgrade to increase API limits
        </Link>
      </Text>
    </Flex>
  )
}
